// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"fdac680d","51":"88c46817","237":"791c1c03","283":"e06930d1","502":"f909157e","626":"2ab05270","638":"082d8f4c","722":"4f32c047","820":"dffeccd5","881":"7bebbaaf","983":"0932131f"}[chunkId] + ".chunk.js";
};